import {createContext, type ReactNode, useContext} from 'react'

interface CapsuleSlide {
  type: string
  [key: string]: unknown
}

interface Capsule {
  id: string
  title: string
  emoji: string
  published: boolean
  subject?: string
  themeId?: string
  slides: CapsuleSlide[]
  status?: string
}

interface AppContextValue {
  capsules: Capsule[]
  ready: boolean
}

const AppContext = createContext<AppContextValue | null>(null)

export function AppProvider({children}: {children: ReactNode}) {
  return (
    <AppContext.Provider value={{capsules: [], ready: true}}>
      {children}
    </AppContext.Provider>
  )
}

export function useApp(): AppContextValue {
  const ctx = useContext(AppContext)
  if (!ctx) throw new Error('useApp must be used within AppProvider')
  return ctx
}

export {AppContext}
